import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, viewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  selector: 'app-formly-chips-type',
  standalone: true,
  imports: [AutoComplete, FormlyModule, FormsModule, ReactiveFormsModule, NgTemplateOutlet],
  templateUrl: './formly-chips-type.component.html',
  styleUrl: './formly-chips-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FormlyChipsTypeComponent extends FieldType {
  protected readonly chips = viewChild(AutoComplete);

  constructor() {
    super();

    effect(() => {
      const chipsValue = this.chips().modelValue() as string[];
      const max = this.props.max;

      if (chipsValue?.length > max) {
        const maxValue = <string[]>Array.prototype.toSpliced.call(chipsValue, -1, 1);

        this.formControl.setValue(maxValue);
      }
    });
  }

  onInputBlur(event: Event): void {
    if (this.props.addOnBlur) {
      const inputValue = (
        this.chips().multiInputEl?.nativeElement?.value ||
        (event.target as HTMLInputElement).value ||
        ''
      ).trim();

      if (inputValue && !this.chips().isSelected(inputValue)) {
        this.chips().updateModel([...(this.chips().modelValue() || []), inputValue]);
        this.props.onBlur?.(this.field, event);

        if (this.chips().multiInputEl?.nativeElement) {
          this.chips().multiInputEl.nativeElement.value = '';
        } else {
          (event.target as HTMLInputElement).value = '';
        }
      }
    }
  }
}
